import _jsx2 from '@babel/runtime/helpers/esm/jsx';
import { ThemeProvider } from 'styled-components';
import ReactDatesField from '@dbh/react-dates-field';
import { memoize } from '@dbh/lodash-extra';
import { THEME_KEY_REACT_DATES } from '@dbh/react-dates-field-theme';
import { THEME_KEY_DATE_PICKER } from '@dbh/date-picker-theme';
import { jsx } from 'react/jsx-runtime';
import { createGetFromLocalTheme } from '@dbh/styled-helpers';
import { change } from 'redux-form/immutable';
import createUseBoundEventCreator from '@dbh/create-use-bound-event-creator';
import { packagesListDateChangerFormName } from '@dbh/redux-form-constants';
import { FIELD_NAMES } from '@dbh/single-date-picker';

const modifyTheme=memoize(a=>{const{[THEME_KEY_REACT_DATES]:b,[THEME_KEY_DATE_PICKER]:{pickerWidth:c,calenderWidth:d,pickerWrapperTop:e}}=a;return {...a,[THEME_KEY_REACT_DATES]:{...b,datePickerWrapper:{...b.datePickerWrapper,top:e},datePickerControllerWrapper:{...b.datePickerControllerWrapper,width:c,calenderWidth:d}}}});

const getFromLocalTheme=createGetFromLocalTheme(["theme",THEME_KEY_DATE_PICKER]);const getFromDatePickerTheme=getFromLocalTheme;

/**
 * Dispatched to programmatically open the calendar widget.
 * @return {Object} .
 */const openCalendarWidget=()=>change(packagesListDateChangerFormName,FIELD_NAMES.isCalendarVisible,!0);const useOpenCalendarWidget=createUseBoundEventCreator(openCalendarWidget);

const DatePicker=a=>/*#__PURE__*/_jsx2(ThemeProvider,{theme:modifyTheme},void 0,/*#__PURE__*/jsx(ReactDatesField,{...a}));DatePicker.displayName="DatePicker";

export { DatePicker as default, getFromDatePickerTheme, openCalendarWidget, useOpenCalendarWidget };
